import MaxImage from '../Media/Max.png'
import ArthurImage from '../Media/Artur.png'
import TajImage from '../Media/taj.png'
import Rob from '../Media/rob.png'
import Vitaly from '../Media/Vitaly.png'
const CoachesList = 
[
{
    name: "Max",
    belt:"Black Belt",
    headinstructor: 1,
    description: "Black belt under Jorge Britto, with nearly 15 years of experience.",
    accomplishments:["Canadian National Champion", "Multiple Time IBJJF Open Champion", "IBJJF American Nationals Bronze Medalist", "Multiple Time Ontario Open Gold Medalist", "Amateur and Professional MMA Experience"],
    image:MaxImage
},

{
  name: "Vitaly",
  belt:"Black Belt",
 
  description: "Black belt with over 10 years of experience",
  accomplishments:["Grappling Industries Gold Medalist", "ADCC Canada Silver Medalist", "Ontario Open Silver Medalist"],
  image:Vitaly
},
{
  name: "Rob",
  belt:"Black Belt",
 
  description: "Black belt with nearly 20 years of experience.",
  accomplishments:["Oshawa Open Gold Medalist", "Professional MMA Experience"],
  image:Rob
},
{name: "TG",
  belt:"Brown Belt",
  accomplishments:["Fighter of the Year and Knockout of the Year award winner in 2022", "MMA Champion", "IBJJF International Competitor"],
  description: "TG is one of the best local MMA prospects and owns a brown belt in Brazilian Jiu-Jitsu. Over a decade of MMA and Jiu-Jitsu experience.",
  image:TajImage

},

  {name: "Arthur",
    belt:"Blue Belt",
    accomplishments:["IBJJF London Open Bronze Medalist", "AJP Gold Medalist", "Next-Gen Gold Medalist", "Ontario Open Silver Medalist"],
    description: "A blue belt in BJJ, Arthur has 4 years of Jiujitsu experience. ",
    image:ArthurImage

  },



]
  
  export default CoachesList;
  